module.exports = __webpack_public_path__ + "static/img/proImg8.ce15c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg8.png
// module id = Okez
// module chunks = 1